// extracted by mini-css-extract-plugin
export default {"root":"root--SDAbW","header":"header--NM2_H","buttons":"buttons--BGVWz","content":"content--COpJd"};